"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fiumefreddo-di-sicilia": {
    "871a1208": [{
      "hkey": "d1a6e14f",
      "slug": "fiumefreddo-di-sicilia",
      "name": "Fiumefreddo di Sicilia",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "d1a6e14f",
      "slug": "fiumefreddo-di-sicilia",
      "name": "Fiumefreddo di Sicilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c4332804": [{
      "hkey": "d1a6e14f",
      "slug": "fiumefreddo-di-sicilia",
      "name": "Fiumefreddo di Sicilia",
      "primary": true,
      "skipSearch": false
    }],
    "diana": [{
      "hkey": "d1a6e14f",
      "slug": "fiumefreddo-di-sicilia",
      "name": "Fiumefreddo di Sicilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d2773c75": [{
      "hkey": "d1a6e14f",
      "slug": "fiumefreddo-di-sicilia",
      "name": "Fiumefreddo di Sicilia",
      "primary": true,
      "skipSearch": false
    }],
    "feudogrande": [{
      "hkey": "d1a6e14f",
      "slug": "fiumefreddo-di-sicilia",
      "name": "Fiumefreddo di Sicilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eb145cdb": [{
      "hkey": "d1a6e14f",
      "slug": "fiumefreddo-di-sicilia",
      "name": "Fiumefreddo di Sicilia",
      "primary": true,
      "skipSearch": false
    }],
    "gona": [{
      "hkey": "d1a6e14f",
      "slug": "fiumefreddo-di-sicilia",
      "name": "Fiumefreddo di Sicilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6e7b8710": [{
      "hkey": "d1a6e14f",
      "slug": "fiumefreddo-di-sicilia",
      "name": "Fiumefreddo di Sicilia",
      "primary": true,
      "skipSearch": false
    }],
    "liberto-san-biagio": [{
      "hkey": "d1a6e14f",
      "slug": "fiumefreddo-di-sicilia",
      "name": "Fiumefreddo di Sicilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1028873d": [{
      "hkey": "d1a6e14f",
      "slug": "fiumefreddo-di-sicilia",
      "name": "Fiumefreddo di Sicilia",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-boria": [{
      "hkey": "d1a6e14f",
      "slug": "fiumefreddo-di-sicilia",
      "name": "Fiumefreddo di Sicilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;